export default "__VITE_ASSET__0IrTTLVK__"